export default __webpack_public_path__ + "static/media/sucu_desk.8437f642.svg";